import { PriceAndSaleInfo } from '../PriceAndSaleInfo/PriceAndSaleInfo';
import { useBiddingSection } from '../useBiddingSection';
import { useHasValuationsToDisplay } from '../Valuations/useHasValuationsToDisplay';
import { Valuations } from '../Valuations/Valuations';

import { ProxyCTA } from './ProxyCTA';

import styles from './SaleActive.module.scss';

export const SaleActive: React.FC = () => {
	const { isOwnedByUserDealership } = useBiddingSection();

	const hasValuationsToDisplay = useHasValuationsToDisplay();

	return (
		<>
			<PriceAndSaleInfo badgeVariant="saleCountdown" />
			{hasValuationsToDisplay ? <Valuations /> : null}
			{/* ProxyCTA only shows here on desktop and tablet */}
			{!isOwnedByUserDealership ? (
				<div className={styles.hideOnMobileWrapper}>
					<ProxyCTA />
				</div>
			) : null}
		</>
	);
};
